.modal {
	display: flex;
	flex-direction: column;
	gap: var(--size-6);
}

.actions {
	display: flex;
	align-items: center;
	gap: var(--size-3);
	justify-content: flex-end;
}
